import type { Testimonial } from '../types/offer';
export const featuredTestimonial: Testimonial = {
  name: 'Rahman K.',
  location: 'ঢাকা',
  role: 'ফ্রিল্যান্সার (+$8,000/মাস)',
  quote: 'আত্মসংশয়ে ভুগছিলাম, আর আজ আন্তর্জাতিক ক্লায়েন্টরা আমাকে ৫ গুণ বেশি পে করে। দ্য আর্জেন্টাইন মাইন্ডসেট আমার চ্যালেঞ্জ দেখার দৃষ্টিভঙ্গিটাই বদলে দিয়েছে। জীবনের সেরা ইনভেস্টমেন্ট।',
  avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/80dc2206-71b8-4a00-939a-78bcdb037bdd.jpg'
};
export const testimonials: Testimonial[] = [{
  name: 'Fatima R.',
  location: 'চট্টগ্রাম',
  role: 'ব্যবসার মালিক',
  quote: 'চট্টগ্রামে একজন নারী উদ্যোক্তা হিসেবে আমি সবসময় সবচেয়ে সস্তা অপশন ছিলাম। এই স্ট্র্যাটেজিগুলো কাজে লাগানোর পর আজ আমি আমার মার্কেট লিড করি। এই বই সবকিছু বদলে দিয়েছে।',
  avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/b68498bb-922a-4d80-aca2-bbb9c2ae262e.jpg'
}, {
  name: 'Sohail H.',
  location: 'সিলেট',
  role: 'সেলস প্রফেশনাল',
  quote: 'শুধু পেনাল্টি মাইন্ডসেট অংশটাই দামের ১০ গুণ মূল্যের। প্রতিটি গুরুত্বপূর্ণ নেগোশিয়েশনের আগে আমি এটি ব্যবহার করি। ৬ মাসে আমার ইনকাম দ্বিগুণ হয়েছে।',
  avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/f1d60429-a7bc-4cba-a6a4-7ffa06c158ee.jpg'
}, {
  name: 'Asha D.',
  location: 'ঢাকা',
  role: 'শিক্ষার্থী (এখন ফ্রিল্যান্সিংয়ে $2,500/মাস)',
  quote: 'আমার পরিচিত প্রতিটি উচ্চাকাঙ্ক্ষী মানুষকে আমি এটি রেকমেন্ড করি। এটা শুধু মাইন্ডসেট নয় — একটা অপ্রতিরোধ্য সিস্টেম গড়ার বই। ধন্যবাদ।',
  avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/57bfb06f-f38c-44d3-8c93-841785695808.jpg'
}];
